import React from 'react'
import { Text } from '@leverege/ui-elements'

import Constants from '../../util/Constants'

export default {
  id : 'ps.attr.product.event.subtype.TableCellRenderer',
  objectType : 'product.event',
  attrName : 'product.event.subtype',
  renderer : data => <ProductEventSubtypeRenderer {...data} />
}

function ProductEventSubtypeRenderer( props ) {
  const { value } = props

  if ( !value ) {
    return '-'
  }

  return (
    <Text
      variant={Constants.SHELF_MONITORING_ALERT_TYPES[value]?.variant || 'pill'}>
      {Constants.SHELF_MONITORING_ALERT_TYPES[value]?.value || '-'}
    </Text>
  )
}
